import request from '@/utils/request'

// 查询保证金配置列表
export function listShopDepositConfig(query) {
  return request({
    url: '/shop/deposit/config/list',
    method: 'get',
    params: query
  })
}

// 查询保证金配置分页
export function pageShopDepositConfig(query) {
  return request({
    url: '/shop/deposit/config/page',
    method: 'get',
    params: query
  })
}

// 查询保证金配置详情
export function getShopDepositConfig(id) {
  return request({
    url: '/shop/deposit/config/info',
    method: 'get',
    params: { id }
  })
}

// 新增保证金配置
export function addShopDepositConfig(data) {
  return request({
    url: '/shop/deposit/config/add',
    method: 'post',
    data: data
  })
}

// 修改保证金配置
export function updateShopDepositConfig(data) {
  return request({
    url: '/shop/deposit/config/edit',
    method: 'post',
    data: data
  })
}

// 删除保证金配置
export function delShopDepositConfig(ids) {
  return request({
    url: '/shop/deposit/config/delete',
    method: 'post',
    data: ids
  })
}
